import { encrypt as AesEncrypt, decrypt as AesDecrypt } from 'crypto-js/aes';
import encUtf8 from 'crypto-js/enc-utf8';
import PBKDF2 from 'crypto-js/pbkdf2';
import encHex from 'crypto-js/enc-hex';
import { DEVICE_ID } from './constants';
import { getIV } from './helpers';

const KEY_SIZE = 256 / 32;
const ITERATION_COUNT = 23;
const SALT = '4321';
const KEY = DEVICE_ID;

const IV = getIV();

const key = PBKDF2(KEY, encHex.parse(SALT), {
  keySize: KEY_SIZE,
  iterations: ITERATION_COUNT,
});

const decrypt = (cipherText: string | CryptoJS.lib.CipherParams) =>
  AesDecrypt(cipherText, key, { iv: encHex.parse(IV) }).toString(encUtf8);

const encrypt = (text: string | CryptoJS.lib.WordArray) => AesEncrypt(text, key, { iv: encHex.parse(IV) }).toString();

export default { decrypt, encrypt };
